<script>
import { iconService } from "@/api/icon.service";
import ItemLink from "@/components/widgets/item-link";

export default {
  name: 'ItemSummary',
  props: {
    propertyId: {
      type: Number,
      required: true
    },
    propertyName: {
      type: String,
      required: true
    },
    areas: {
      type: Array, 
      required: true 
    }
  },
  computed: {
    items() {

      let itemCategories = [];
      const itemCount = {};

      this.areas.forEach(area => {
        area.items.forEach(item => {
          if (! item.category ) return;
          const slug = iconService.getCategorySlug(item.category);

          if (! itemCategories.includes(slug) ) {
            itemCount[slug] = 0;
            itemCategories.push(slug);
          }

          itemCount[slug]++;
        });
      });

      itemCategories = itemCategories.sort().map((category, categoryIndex) => {
        const icon = iconService.getIconByCategory(category);

        if (icon) {
          return {
            id: categoryIndex + 2,
            parentId: 2,
            label: icon.name,
            link: `/properties/${this.propertyId}/category/${encodeURIComponent(category)}`,
            icon: icon.icon,
            count: itemCount[category]
          };
        }

        return null;

      });

      return this.splitToChunks(itemCategories, 3);
    }
  },
  methods: {
    splitToChunks(array, parts) {
      let result = [];
      for (let i = parts; i > 0; i--) {
        result.push(array.splice(0, Math.ceil(array.length / i)));
      }
      return result;
    }
  },
  components: { ItemLink }
}
</script>

<style>
  .item-summary.widget .icon {
    display: inline-block;
    min-width: 30px;
  }

  .item-summary.widget .icon > img {
    max-height: 25px;
  }
</style>

<template>
  <div class="item-summary widget">
    <h5><span class="summary-label">Item Summary:</span><span class="property-name">{{ this.propertyName }}</span></h5>
    <div class="row summary">
      <ul class="col-md">
        <li v-for="(item, index) in items[0]" :key="index">
          <ItemLink v-if="item" :item="item" />
        </li>
      </ul>
      <ul class="col-md">
        <li v-for="(item, index) in items[1]" :key="index">
          <ItemLink v-if="item" :item="item" />
        </li>
      </ul>
      <ul class="col-md">
        <li v-for="(item, index) in items[2]" :key="index">
          <ItemLink v-if="item" :item="item" />
        </li>
      </ul>
    </div>
  </div>
</template>